export const DEFAULT_FONT_SIZE = "14px";
export const DEFAULT_FONT_WEIGHT = "400";

export const h1Size = "24px";
export const h1Weight = "300";
export const h1LineHeight = "32px";

export const h2Size = "20px";
export const h2Weight = 300;
export const h2LineHeight = "24px";

export const h3Size = "20px";
export const h3Weight = "700";
export const h3LineHeight = "24px";

export const h4Size = "18px";
export const h4Weight = "700";
export const h4LineHeight = "24px";

export const h5Size = "14px";
export const h5Weight = "700";
export const h5LineHeight = "20px";

export const h6Size = "12px";
export const h6Weight = "700";
export const h6LineHeight = "16px";

export const body1Size = DEFAULT_FONT_SIZE;
export const body1Weight = DEFAULT_FONT_WEIGHT;
export const body1LineHeight = "20px";

export const body2Size = "12px";
export const body2Weight = DEFAULT_FONT_WEIGHT;
export const body2LineHeight = "16px";

export const subtitle1Size = "14px";
export const subtitle1Weight = DEFAULT_FONT_WEIGHT;
export const subtitle1LineHeight = "24px";

export const subtitle2Size = "12px";
export const subtitle2Weight = "500";
export const subtitle2LineHeight = "20px";

export const overlineSize = "12px";
export const overlineWeight = DEFAULT_FONT_WEIGHT;
export const overlineLineHeight = "32px";
export const overlineLetterSpacing = "1px";
export const overlineTextTransform = "uppercase";

export const captionSize = "12px";
export const captionWeight = DEFAULT_FONT_WEIGHT;
export const captionLineHeight = "20px";
